const changeLogArchive = [
  {
    version: "05.11.04",
    issues: [
      { id: "", description: "Modified previous bug fix with better handling to stop duplication bug." }
    ]
  },
  {
    version: "05.11.03",
    issues: [
      { id: "GCOBSV5-597", description: "Fixed Observation Report defect where exactly six defect types in a section would cause that section not to display." }
    ]
  },
  {
    version: "05.11.02",
    issues: [
      { id: "GCOBSV5-596", description: "Added pre-inspect reject function and validation issues." },
      { id: "GCOBSV5-590", description: "Workflow Step configuration schema moved to individual schemas." }
    ]
  },
  {
    version: "05.10.40",
    issues: [
      { id: "GCOBSV5-586", description: "Fixed issue with invalid subscriber data failing all notification sends that require subscription rules." }
    ]
  },
  {
    version: "05.10.39",
    issues: [
      { id: "GCOBSV5-571", description: "Fixed issue where grades rated STANDARD were not sending notifications." },
      { id: "GCOBSV5-572/80", description: "New feature saves your in-grid filters when you return to the grid from a report or viewing other pages. Also has a filter ON/OFF indicator so you know when you have applied or removed a filter. " }
    ]
  },
  {
    version: "05.10.38",
    issues: [
      { id: "GCOBSV5-569", description: "Fixed issue where changing schemas in history grid to schema with different grid layout was not showing the updated layout." },
      { id: "GCOBSV5-570", description: "Fixed issue with some schemas which were not displaying if a row had associated images in the history grid." }

    ]
  },
  {
    version: "05.10.37",
    issues: [
      { id: "GCOBSV5-555/556", description: "Modified Search, Grid layout and report to use new label property to override title properties." }
    ]
  },
  {
    version: "05.10.36",
    issues: [
      { id: "GCOBSV5-555/556", description: "Created new label property for schemas which will override the title property if it exists, allowing alternate labels (e.g. different language) without breaking scoring and validation logic." },
      { id: "GCOBSV5-546/545/548/549/550", description: "Modified Dashboard charts so they are now driven by data in org (and by) Organization." },
      { id: "GCOBSV5-532", description: "Added Company and Role to Subscription Grid" }
    ]
  },
  {
    version: "05.10.35",
    issues: [
      { id: "", description: "simple fix for null values in notification and lot report" },

    ]
  },
  {
    version: "05.10.34",
    issues: [
      { id: "GCOBSV5-524", description: "Modified the page title that shows up on mobile devices while looking at linked report" },
      { id: "GCOBSV5-526", description: "Modified metadata icons to use glassbit icon rather than default" },
      { id: "GCOBSV5-521", description: "Fixed issue with sending test messages from Subscriber Management page." },
      { id: "GCOBSV5-500", description: "Fixed issue where restoring suspended observations was not using the schema of the suspended observation." }
    ]
  },
  {
    version: "05.10.33",
    issues: [
      { id: "GCOBSV5-520", description: "Fixed issue with exporting observations with empty date fields." }
    ]
  },
  {
    version: "05.10.31",
    issues: [
      { id: "GCOBSV5-501/504", description: "Modified Email Notification default template to use category totals rather than rule totals." }
    ]
  },
  {
    version: "05.10.30",
    issues: [
      { id: "GCOBSV5-477", description: "Fixed a bug with new browsers building indexdb and throwing an error." }
    ]
  },
  {
    version: "05.10.29",
    issues: [
      { id: "GCOBSV5-482", description: "Multiple changes to generic observation report, including fixing titles on fields and defects." },
      { id: "GCOBSV5-468", description: "Modifying new Observations Quantity Card UI to widen entry field and allow schema to drive label text." },
      { id: "GCOBSV5-471", description: "Modified Observation footer menu to collapse certain items to reduce width of button strip." },
    ]
  },
  {
    version: "05.10.28",
    issues: [
      { id: "", description: "Fixed bug when scoring a schema with rounding rules with toFixed rule." }
    ]
  },
  {
    version: "05.10.27",
    issues: [
      { id: "GCOBSV5-348", description: "Created new Observations Quantity card that lets user add quantities by individual baskets (rather than an estimate/average of each basket). " }
    ]
  },
  {
    version: "05.10.26",
    issues: [
      { id: "GCOBSV5-464", description: "Modified scoring schema and accelerator scoring algorithm to allow rounding raw and weighted scores at the rule level using various rounding techniques, including custom roundhalfdown, which will round .5 DOWN to the previous integer. " },
      { id: "GCOBSV5-414", description: "Fixed issue where View Read-Only observation was showing on Dashboard button strip." },
      { ID: "GCOBSV5-466", description: "Fixed issue where clicking on Images button in Observations when there were no local images was throwing an error. This is a different issue from capturing an image on observation and not seeing it when clicking on the images button." }
    ]
  },
  {
    version: "05.10.25",
    issues: [
      { id: "GCOBSV5-436", description: "Added code to handle short URLs in SMS texts for viewing reports.." }
    ]
  },
  {
    version: "05.10.24",
    issues: [
      { id: "GCOBSV5-463", description: "Fixed issue where clicking on Refresh Environment while in observation generates an error." },
      { id: "GCOBSV5-450", description: "Modified Dashboard inspector/observer search to include all users who have access to locations that the logged-in user has access to." }
    ]
  },
  {
    version: "05.10.23",
    issues: [
      { id: "GCOBSV5-445", description: "Added the ability to prompt users upon saving an observation if a specific grade is scored to REINSPECT the observation or to continue with the posting. This is schema-driven." },
      { id: "GCOBSV5-447", description: "Increased card icons in observations for easier selection." },
      { id: "GCOBSV5-448", description: "Replaced Observations icon with camera for easier identification." },
      { id: "GCOBSV5-446", description: "Moved Observations Score button to separate it from other footer buttons." }
    ]
  },
  {
    version: "05.10.22",
    issues: [
      { id: "GCOBSV5-435", description: "Added a Home button to the report screen (if user is NOT coming from an email link)." },
      { id: "GCOBSV5-422", description: "Fixed issue with data list not refreshing detail sublist upon editing the list." },
      { id: "GCOBSV5-430", description: "Fixed issue where changing search schema was not setting schema search properties. Note that this changes functionality - changing the Add Observation Schema will no longer change the search schema." },
      { id: "GCOBSV5-437", description: "Added configuration for logging only if error occurred in observation post." },
      { id: "GCOBSV5-425", description: "Added ability to log telemetry for observation posts to the back end." },
      { id: "GCOBSV5-427", description: "Added flag to orgConfig that allows turning on event logging." }
    ]
  },
  {
    version: "05.10.21",
    issues: [
      { id: "GCOBSV5-420", description: "Fixes issue with shared reports where users are trying to view report on browser that has never been logged in." }
    ]
  },
  {
    version: "05.10.19",
    issues: [
      { id: "GCOBSV5-415", description: "Added feature to allow user to purge locally-queued observations so they don't try to repost" }
    ]
  },
  {
    version: "05.10.18",
    issues: [
      { id: "GCOBSV5-407", description: "Fixed bug with subscriptions where auto-notify subscriptions were not transforming data before sending to email template." }
    ]
  },
  {
    version: "05.10.17",
    issues: [
      { id: "GCOBSV5-360", description: "Modified Report grading summary to display <1 if percentage is between 0 and 1." },
      { id: "GCOBSV5", description: "Modified subscriptions to allow custom formatting" },
      { id: "GCOBSV5-405", description: "Fixed bug where changes to Subscription maintenance remove the active flag." }
    ]
  },
  {
    version: "05.10.15",
    issues: [
      { id: "GCOBSV5-399", description: "Fixed issue with new observation buttons causing score button to push off screen" },
      { id: "GCOBSV5-400", description: "Added feature that checks the minimum supported application version in the schema and does NOT load schemas that do not support the minimum." },
      { id: "GCOBSV5-396", description: "Fixed issue with standard report where error is thrown if environment vars are not used." }
    ]
  },
  {
    version: "05.10.09",
    issues: [
      { id: "GCOBSV5-327", description: "Fixed issue where clicking on an image in a report a SECOND time does NOT bring up the image." },
      { id: "GCOBSV5-359", description: "Modified custom field filter colors to black on white background for readability." },
      { id: "GCOBSV5-344", description: "Fixed standard observations report to show pallets separated by commas (generically - checks for an array and uses join)." },
      { id: "GCOBSV5-357", description: "Modified schema, report data factory and generic observation report to use custom fields." }
    ]
  },
  {
    version: "05.10.08",
    issues: [
      { id: "GCOBSV5-353", description: "Fixed issue with Shared Report email link for email user to view report online." }
    ]
  },
  {
    version: "05.10.07",
    issues: [
      { id: "GCOBSV5-351", description: "New Feature that allows authorized users to preview Observation Grade without having to save the observation first. Meant for managers, admins and testers, not inspectors." }
    ]
  },
  {
    version: "05.10.06",
    issues: [
      { id: "GCOBSV5-325", description: "Modified Inbound Queue to refresh when user changes location." }
    ]
  },
  {
    version: "05.10.04",
    issues: [
      { id: "GCOBSV5-", description: "Deployed for MRA/Inbound Queue Integration on Test systems." }
    ]
  },
  {
    version: "05.10.04",
    issues: [
      { id: "GCOBSV5-313/315/317/293/295", description: "Further UI changes to Inbound Queue Observation card." }
    ]
  },
  {
    version: "05.10.03",
    issues: [
      { id: "GCOBSV5-314/318", description: "UI changes to Inbound Queue Observation card." }
    ]
  },
  {
    version: "05.10.02",
    issues: [
      { id: "GCOBSV5-", description: "Implemented Inbound Queue/Api Lookup Card that handles removing inbound queue pallets upon save." }
    ]
  },
  {
    version: "05.10.01",
    issues: [
      { id: "GCOBSV5-302", description: "Created backend for inbound queue" },
      { id: "GCOBSV5-292", description: "Create inbound queue UI with button strip" },
      { id: "GCOBSV5-311/305/312", description: "Implemented manual and autorefresh for inbound queue as well as deleting an inbound queue row." },
      { id: "GCOBSV5-308", description: "Allow user to generate new observation from inbound queue row." }
    ]
  },
  {
    version: "05.09.13",
    issues: [
      { id: "GCOBSV5-240", description: "Modified subscription grid column titles." },
      { id: "GCOBSV5-300/301", description: "Supporting activating/deactivating subscribers and not including deactivated subscribers in subscription pushes." }
    ]
  },
  {
    version: "05.09.11",
    issues: [
      { id: "GCOBSV5-298", description: "Added Multi-pallet API Lookup Card support" },
      { id: "GCOBSV5-291", description: "Added TextParserMap card with PTI code support." }
    ]
  },
  {
    version: "05.09.10",
    issues: [
      { id: "GCOBSV5-283", description: "Fixed defect where Data API Dimension uploading was skipping uploading defect-level dimensions." },
      { id: "GCOBSV5-297", description: "Fixed issue with sharing where email link had wrong (hard-wired) gcid in it resulting in observation not being found for linked report." },
      { id: "GCOBSV5-296", description: "Fixed issue for sharing reports where if a grade for report schema is NOT in the grade-color data list, the call to fetch a random color was failing." }
    ]
  },
  {
    version: "05.09.09",
    issues: [
      { id: "GCOBSV5-", description: "Fixed a bug with Lot Report when schema has child search properties." }
    ]
  },
  {
    version: "05.09.08",
    issues: [
      { id: "GCOBSV5-281", description: "Used new Names OrgConfig node to apply long name to Shared Email Message Subject." }
    ]
  },
  {
    version: "05.09.07",
    issues: [
      { id: "GCOBSV5-", description: "Fixed defect with ObservationGenericReport - complex category and card titles were not registering properly." }
    ]
  },
  {
    version: "05.09.06",
    issues: [
      { id: "GCOBSV5-", description: "Modified Accelerator scoring algorithm, ObservationGenericReport(2) and schema to allow scoring values that do not substract from 100 and also include rounding and other rules required by Walmart-like schema." }
    ]
  },
  {
    version: "05.09.05",
    issues: [
      { id: "GCOBSV5-237", description: "Now posts subscription alerts upon posting an observation" },
      { id: "GCOBSV5-279", description: "Modified the way subscriptions are posted so that they are queued at the notification service so that the UI can quickly return to the user." },
      { id: "GCOBSV5-278", description: "Fixed About Box Core API Last Built date" },
      { id: "GCOBSV5-275", description: "Implemented ability to send subscribers SMS Messages." },
      { id: "GCOBSV5-234", description: "Implemented ability to send subscribers a TEST email message from the subscription management page." }
    ]
  },
  {
    version: "05.09.04",
    issues: [
      { id: "GCOBSV5-270", description: "Add how to get required token to call Data API endpoints." },
      { id: "GCOBSV5-269", description: "Include Category defect and dimension URLs in the Data API page." },
      { id: "GCOBSV5-", description: "Modified UI Search Strip to include CHILD types in search - this means that the search now supports Supplier Pallet and Famous Pallet searches from the search strip." },
      { id: "GCOBSV5-", description: "Created data endpoint to pull child data information by the a data API by FACTTYPE (e.g. SupplierPallet, FamousPallet" },
      { id: "GCOBSV5-268", description: "Modified Core API and client so that JSON upload includes uploading any child dimensions (e.g. Supplier Pallet, Famous Pallet) identified in the schema data API" },
      { id: "GCOBSV5-265", description: "Modified Star Download to include pallet file generation" }
    ]
  },
  {
    version: "05.09.03",
    issues: [
      { id: "GCOBSV5-263", description: "Fixed issue Dashboard Enterprise Location totals not showing correct Lifetime-to-date (LTD) totals (not including previous years)" },
      { id: "GCOBSV5-264", description: "Fixed issue with customized history grid layout getting reset when moving between Home and Dashboard." },
      { id: "GCOBSV5-248", description: "Modified Data API page to include links to all Data API endpoints" },
      { id: "GCOBSV5-247", description: "Fixed bug on Data API page - changes to the search schema were not updating the URL" },
      { id: "GCOBSV5-258", description: "Fixed bug (found in TEST ALL schema) where if a date field was empty, the app blew up." },
      { id: "GCOBSV5-260", description: "Created menu choice - available only to glassbit.support role users - to upload dimensional and flat versions of grid observations to data api tables in the core (after testing, this will be moved to happening on post of each observation) [Experimental]." }
    ]
  },
  {
    version: "05.09.02",
    issues: [
      { id: "GCOBSV5-258", description: "Fixed bug where JSON download was taking the schema from the Schema Selector, not the search criteria. This led to defects potentially being generated from the wrong schema." },
      { id: "GCOBSV5-259", description: "Created new Json FLAT download choice which will download the grid records as a flattened json file. You still need to bring it in as Json, but you only need to expand it once - on record. Note to turn OFF using the parent column name in the column to get cleaner column names." }
    ]
  },
  {
    version: "05.09.01",
    issues: [
      { id: "GCOBSV5-257", description: "New function that allows user to generate dimensional data from observation data and download as JSON (experimental)" },
      { id: "GCOBSV5-241", description: "Fixed bug that was making the autorefresh toggle not reflect the actual state of autorefresh." },
      { id: "GCOBSV5-232", description: "Modified subscription management code and core so that editing a subscription works properly. Still only supports schemas that support ObservationResult subscription." }
    ]
  },
  {
    version: "05.08.10",
    issues: [
      { id: "GCOBSV5-250", description: "Modified JSON download structure to flatten all non-defect fields and set multiplier values for defects that are involved in scoring (and 0 for non-scoring defects)" }
    ]
  },
  {
    version: "05.08.09",
    issues: [
      { id: "GCOBSV5-256", description: "Fixed bug with Multiplier/Accelerator scoring in which a card with its own scoringCategory override multiplier was not using that multiplier, but was using the category-level multiplier." },
      { id: "GCOBSV5-246", description: "Modified JSON downloads to expand to ALL exportable properties of schema. A property (card) can opt OUT by including a DataApi.exclude=true flag." }
    ]
  },
  {
    version: "05.08.08",
    issues: [
      { id: "GCOBSV5-244", description: "Supress specific system roles in roles dropdown." },
      { id: "GCOBSV5-243", description: "Check for reserved user names when user creates new User Id" },
      { id: "GCOBSV5-245", description: "Modify login error messages to be more clear about what actions to take." }
    ]
  },
  {
    version: "05.08.07",
    issues: [
      { id: "GCOBSV5-239", description: "Fixed bug caused by new default Activity Charts showing as collapsed - expanding was not triggering a data refresh." }
    ]
  },
  {
    version: "05.08.06",
    issues: [
      { id: "GCOBSV5-", description: "Subscription Event Management (Experimental) allows DELETING existing subscribers. (Experimental)." },
      { id: "GCOBSV5-", description: "Subscription Event Management (Experimental) allows generating NEW subscribers. (Experimental)." }
    ]
  },
  {
    version: "05.08.05",
    issues: [
      { id: "GCOBSV5-238", description: "Fixed bug where Data List Edit button was not working." },
      { id: "GCOBSV5-222", description: "Fixed issue where adding a new user was picking up different name and password values." }
    ]
  },
  {
    version: "05.08.04",
    issues: [
      { id: "GCOBSV5-", description: "Modified subscriptions to use different Sendgrid email template (data not complete)" },
      { id: "GCOBSV5-", description: "Modified STRAWS schema to point to correct report type)" },
      { id: "GCOBSV5-", description: "wired up back end subscriptions events (does NOT work for posting! Use resend menu item)" },
      { id: "GCOBSV5-141", description: "Initial draft of the generic standard Observations report" },
      { id: "GCOBSV5-229", description: "Fixed issue where user clicks to see user docs and if there are no associated docs, system blows up real good. now notifies user." },
      { id: "GCOBSV5-235", description: "Fixed issue where user clicks to see user images on history grid and nothing happens to notify the user that there are NO associated user images. Now notifies user." }
    ]
  },
  {
    version: "05.08.03",
    issues: [
      { id: "GCOBSV5-227", description: "Fixed a bug where double-clicking on a dataList before the sublist had been established threw an error." },
      { id: "GCOBSV5-226", description: "Fixed an issue with fetching all users for user management - producing what appear like multiple records for the same user." },
      { id: "GCOBSV5-", description: "Created shell of new generic observations report." },
      { id: "GCOBSV5-223", description: "Fixed defect with Observations card calculator" },
      { id: "GCOBSV5-", description: "Added Subscription Management Page (experimental)" },
      { id: "GCOBSV5-", description: "Added Send Test Message button to Subscription Management Page Panel (not implemented) (experimental)" }
    ]
  },
  {
    version: "05.08.02",
    issues: [
      { id: "GCOBSV5-", description: "Added ability to download all selected observations in grid as a COMPACT Json file from Grid Share Button. This gives a clean analytics dataset (experimental)" }
    ]
  },
  {
    version: "05.08.01",
    issues: [
      { id: "GCOBSV5-", description: "Added ability to download current selected observation as a Json file from Grid Share Button (experimental)" },
      { id: "GCOBSV5-209", description: "Make all Dashboard grade charts use consistent colors for grades (from the colorgrade datalist)" },
      { id: "GCOBSV5-218", description: "Default auto-collapse the dashboard Enterprise chart" },
      { id: "GCOBSV5-215", description: "Lot Report Readings section Pallet IDS label changed to No Pallet ID" },
      { id: "GCOBSV5-210", description: "History Grid location and observation filters default to ALL if user has ALL search rights" },
      { id: "GCOBSV5-219", description: "Dashboard non-grade charts now get their colors supplied randomly from the colornongrade datalist" },
      { id: "GCOBSV5-220", description: "For Dashboard stacked bar charts, now puts highest value (as defined by the colorgrade datalist) at the top of the stack" },
      { id: "GCOBSV5-208", description: "Instead of throwing error on csv import bad line, return" },
      { id: "GCOBSV5-", description: "Implementing ability to resend Subscription Notifications. This is in test stages. No maintenance yet (experimental)." }

    ]
  },
  {
    version: "05.07.16",
    issues: [
      { id: "GCOBSV5-172", description: "Fixed defect with saving and restoring history grid layout" },
      { id: "GCOBSV5-206", description: "Modified Data API Access page to include filter for schema and dates that drive the actual URL." },
      { id: "GCOBSV5-205", description: "Changed Label and menu choice text for Data API Instructions to Data API Access" }
    ]
  },
  {
    version: "05.07.15",
    issues: [
      { id: "GCOBSV5-150", description: "New feature allows users to import items into existing Data Lists from a csv file. The file needs name and id columns and will import into and overwrite an existing list." },
      { id: "GCOBSV5-194", description: "Modified schemas to support new ACCUMULATOR schema property for collapsible rows. This will total boxes BY sample in the Berry Fresh use case." },
      { id: "GCOBSV5-203", description: "Created new page that shows instructions, including URL and authorization bearer token for fetching observations via the Data API." },
      { id: "GCOBSV5-204", description: "Modified Data List import to pull name and value by POSITION, disregarding the field names in csv" }
    ]
  },
  {
    version: "05.07.14",
    issues: [
      { id: "GCOBSV5-182", description: "Modified Lookup Entity Import to allow multiple schemas to be imported in a single file and generate appropriate entities. Genericized so that this is driven by schema. Note this requires import file structure changes (Schema prop and value)" },
      { id: "GCOBSV5-183", description: "Modified Lookup Entity to modified ADD to show dropdown of schemas available for the Entity Type so that the dialog is for the schema." },
      { id: "GCOBSV5-180", description: "Modified Observation Lookup Entity dropdown to restrict possible entities to the current schema." }
    ]
  },
  {
    version: "05.07.13",
    issues: [
      { id: "GCOBSV5-168/179/181", description: "UI cleanup and expansion of Lookup Entity import dialog" },
    ]
  },
  {
    version: "05.07.12",
    issues: [
      { id: "GCOBSV5-167", description: "Modified Search Strip Location dropdown to include ALL choice." },
      { id: "GCOBSV5-178", description: "Modified the backend to allow a location search for all to check if user has global.search role. If so, then ALL locations for gcid will be searched. If not, then ONLY the locations the user has been assigned will be searched." },
      { id: "GCOBSV5-154", description: "Fixed PERNICIOUS bug that was causing the famous-lot-nbr card to change to each value that we were setting in the lookup entity." },
      { id: "GCOBSV5-164", description: "Modified Total Qty Card to show subvalues as well as total count." },
      { id: "GCOBSV5-156", description: "Fixed defect in Lot Report - if a pallet showed multiple times then it was being counted twice. Now check for UNIQUE supplier pallet numbers." },
      { id: "GCOBSV5-157", description: "Based on schema lookup entity value, removes the lookup entity used by selecting from lookup dropdown upon save." }
    ]
  },
  {
    version: "05.07.11",
    issues: [
      { id: "GCOBSV5-162", description: "Modified Lookup Entity identifiers code to make labels an option and process dates and multiple supplier pallets" },
      { id: "GCOBSV5-155", description: "Modified the Loookup Entity import to combine lines by sample. Note that this is exclusive to the modified Lot csv" }
    ]
  },
  {
    version: "05.07.10",
    issues: [
      { id: "GCOBSV5-151", description: "Modified Lookup Entity Import to show a grid of imported data before user saves" },
      { id: "GCOBSV5-152", description: "Modified the Lookup Entity Import to show any import errors and block the user from attempting to save a flawed import." }
    ]
  },
  {
    version: "05.07.09",
    issues: [
      { id: "GCOBSV5-135", description: "Built initial Lot csv lookup entity import. This is hard-coded for lots and the specific file. If this looks good we will build it out generically." },
      { id: "GCOBSV5-149", description: "Modified the Lookup Entity delete to split into two different types: the first deletes JUST the current record. The second deletes ALL records with the current entity key value." }
    ]
  },
  {
    version: "05.07.08",
    issues: [
      { id: "GCOBSV5-86", description: "Fixed issue with images and documents not showing upon update." },
      { id: "GCOBSV5-90", description: "Now allows users to delete attached documents while updating an observation." },
      { id: "GCOBSV5-88", description: "Now allows users to delete user images while updating an observation." },
      { id: "GCOBSV5-140", description: "Fixed bug that did not show or allow deleting NEWLY attached user images." },
      { id: "GCOBSV5-134", description: "Modified Lookup Entity Entry to show dropdown if multiple entities exist for same lot number." },
      { id: "GCOBSV5-132", description: "Modified Lookup Entity to allow MULTIPLE entries for the same entity key (e.g. lot number)" },
      { id: "GCOBSV5-145", description: "Generated read-only view of an observation that is available even after update period." },
      { id: "GCOBSV5-147", description: "Changed standard size reduction for uploaded images from 300x300 to 2048x2048" },
      { id: "GCOBSV5-146", description: "Fixed defect where documents selected to view from history grid were not showing" },
      { id: "GCOBSV5-148", description: "Created fallback images for documents and user images that cannot be found" }
    ]
  },
  {
    version: "05.07.07",
    issues: [
      { id: "GCOBSV5-137", description: "Fixed bug discovered by Rodrigo that was preventing updating on an observation that did not have a value in the pallet tags supplier tag property." },
      { id: "GCOBSV5-136", description: "Fixed bug causing attached documents not to upload properly." },
      { id: "GCOBSV5-133", description: "Modified Lookup Entities to auto-generate an identifier field which is driven by schema definitions for properties that represent a unique lookup entity. Still work to do to implement this in actual lookup." },
      { id: "GCOBSV5-138", description: "Fixed bug with downloading attached documents from History Grid menu. Now downloads to browser correctly." }
    ]
  },
  {
    version: "05.07.06",
    issues: [
      { id: "GCOBSV5-131", description: "Modified the Duplicate feature so that it updates the inspector, location, inspection date and environ properties with CURRENT logged in user information rather than a straight duplication of the source observation." },
    ]
  },
  {
    version: "05.07.05",
    issues: [
      { id: "GCOBSV5-49", description: "Fixed bug when the user token expired, the system still tried to contact the core API and threw error messages continually until the user logged in again." },
      { id: "GCOBSV5-52", description: "Added a prop for showing legends on activity charts. Set it to false so legend should not show." },
      { id: "GCOBSV5", description: "Activated the new multi-commodity template in Sendgrid for email shares." },
      { id: "GCOBSV5-78/126", description: "Lot Report thumbnail images and documents are now clickable. They will open in a new window." },
      { id: "GCOBSV5-87/89", description: "Observation images and documents can now be deleted in NEW observations (updated observations will follow)" },
      { id: "GCOBSV5-91", description: "Disallow auto-refresh on Moble Chrome pull downs." },
      { id: "GCOBSV5-128", description: "Created new Change History page with a list of all versions and changes" },
      { id: "GCOBSV5-129", description: "Modify About box to make values more legible" }
    ]
  },
  {
    version: "05.07.04",
    issues: [
      { id: "GCOBSV5-120", description: "Fixed bug which was causing updated observations with different schema from schema selector to set the schema TO the schema selector value instead of the original observation schema." },
      { id: "GCOBSV5-124", description: "Changed title of Dashboard panel to Chart Filters from History Grid" },
      { id: "GCOBSV5-83", description: "Shared Lot Report Email contents now contain a section for EACH commodity represented by the lot report" },
      { id: "GCOBSV5-125", description: "Fixed a bug in the lot report where the location was reflecting the logged-in user location, NOT the location of the observations in the report itself." },
      { id: "GCOBSV5-121", description: "Changed Lot Report so Baxlo Measurements only show for BLUEBERRY schema" },
      { id: "GCOBSV5-122", description: "Modified lot report images to use a thumbnail if available (generated automatically upon image upload). If a thumbnail is not available then the report will fall back to the full image size." },
    ]
  },
  {
    version: "05.07.03",
    issues: [
      { id: "GCOBSV5-85", description: "Added Observation Score to Lot Report Header Information." },
      { id: "GCOBSV5-95", description: "Added Baxlo Measurement to Lot Report Header Information and removed it from Readings section." },
      { id: "GCOBSV5-108", description: "Modified all schema scoring ranges so that Poor is now 50-69 rather than 60-69" },
      { id: "GCOBSV5-106", description: "Modified copy properties to include all fields in UnderInspection but pallet tags." },
      { id: "GCOBSV5-107", description: "Modified Lookup Entity properties to include all fields in UnderInspection including pallet tags." },
      { id: "GCOBSV5-109", description: "Modified Lot Report to only pull observations for the current search schema (rather than across all schemas) so we don't duplicate pallets." },
      { id: "GCOBSV5-42", description: "Modified Lot Report Underweight calculation so that it gets percentage of baskets underweight rather than total berries underweight." },
      { id: "GCOBSV5-79", description: "Modified Variety Code label to Variety" },
      { id: "GCOBSV5-104", description: "Fixed Lot Report bug where pallet counts were not calculating properly." },
      { id: "GCOBSV5-103", description: "Added Schema to history grid when search is on ALL schema." },
      { id: "GCOBSV5-105", description: "Fixed defect where changing the search schema was not resetting the grid to that schema column definitions" }
    ]
  },
  {
    version: "05.07.02",
    issues: [
      { id: "", description: "Temporarily removing document download menu item while we research defect." },
      { id: "GCOBSV5-46", description: "Added security keys for adding and deleting data lists." },
      { id: "GCOBSV5-50", description: "Modified toast notification after saving data list that users must log out and log back in to see updates." },
      { id: "GCOBSV5-55", description: "Removed Type column from Data List table." },
      { id: "GCOBSV5-51", description: "Modified Observation Detail panel to remove object type and size properties." },
      { id: "GCOBSV5-45", description: "Fixed problem with grid actions not recognizing first record being selected." },
      { id: "GCOBSV5-47,53", description: "Modifications to Data list editor to keep action buttons available while scrolling." },
      { id: "GCOBSV5-40", description: "Updated email lot summary to match format of report itself. Note that currently we cannot display multi-commodity lot summaries in email (works in report). Backlog item." }
    ]
  },
  {
    version: "05.07.01",
    issues: [
      { id: "", description: "Production Deployment of Observations Version 5" }

    ]
  }
];

export default changeLogArchive;
